import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { listStyles } from "@insite/content-library/Widgets/MyLists/MyListsList";
import { css } from "styled-components";

listStyles.centeringWrapper = mergeToNew(listStyles.centeringWrapper, {
  css: css`
    width: 100%;
  `
});

